"use strict";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var employees = document.querySelectorAll("li");
var ul = document.querySelector("ul");
var toNumber = function(item) {
    return +item.dataset.salary.replace(/[$,]/g, "");
};
function sortList() {
    for(var _len = arguments.length, list = new Array(_len), _key = 0; _key < _len; _key++){
        list[_key] = arguments[_key];
    }
    var _ul;
    list.sort(function(a, b) {
        return toNumber(b) - toNumber(a);
    });
    (_ul = ul).append.apply(_ul, _to_consumable_array(list));
}
function getEmployees() {
    for(var _len = arguments.length, list = new Array(_len), _key = 0; _key < _len; _key++){
        list[_key] = arguments[_key];
    }
    var result = [];
    list.forEach(function(item) {
        var employer = {};
        employer.name = item.textContent.trim();
        employer.position = item.dataset.position;
        employer.salary = item.dataset.salary;
        employer.age = item.dataset.age;
        result.push(employer);
    });
    return result;
}
sortList.apply(void 0, _to_consumable_array(employees));
getEmployees.apply(void 0, _to_consumable_array(employees));

//# sourceMappingURL=index.2589524e.js.map
